'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("WelcomePopinController", function ($scope, $location, $http, abonnementAlerteService, $session, $notifications) {
  $scope.params = {
    alerteMailVersionMaj: true,
    alerteMailPublicationMaj: true
  };
  $scope.user = $session.getUser();

  /*
  $scope.changeAlerteMailVersion = () => {
      abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailMaj).then((data) => {
          $notifications.info(($scope.params.alerteMailMaj) ? "Notification mail activée" : "Notification mail désactivée");
      });
   }
   $scope.changeAlerteMailPublication = () => {
      abonnementAlerteService.setAlerteNouvellePublication($scope.params.alerteMailMaj).then((data) => {
          $notifications.info(($scope.params.alerteMailMaj) ? "Notification mail activée" : "Notification mail désactivée");
      });
  };
  */
  $scope.validateAndSave = function () {
    abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailVersionMaj).then(function () {
      abonnementAlerteService.setAlerteNouvellePublication($scope.params.alerteMailPublicationMaj);
    });
    $scope.errorMessage = null;
    $http.put('/rest/home/welcome-screen-off');
    $scope.$close();
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/welcome/welcome.js
// module id = 2791
// module chunks = 13